import styled from 'styled-components'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Icon_Drag } from '../../styles/icons'
import GridListRow from './GridListRow'

const RowWrapper = styled.div`
    position: relative;
`

const DragHandle = styled.div`
    position: absolute;
    left: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    cursor: grab;
    color: ${({ theme }) => theme.text?.secondary || '#aaa'};
    display: flex;
    align-items: center;
    padding: 0.25rem;
    touch-action: none;
    opacity: 0.4;

    &:hover {
        opacity: 1;
    }

    &:active {
        cursor: grabbing;
    }
`

const SortableGridListRow = (props) => {
    const { row, rowIdx, sortableId } = props
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: sortableId })

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    }

    return (
        <RowWrapper ref={setNodeRef} style={style}>
            <DragHandle {...attributes} {...listeners}>
                {Icon_Drag}
            </DragHandle>
            <GridListRow {...props} />
        </RowWrapper>
    )
}

export default SortableGridListRow
